@if (showSpinner) {
  <div class="waiting-spinner">
    <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
    <p>{{ isSending ? 'Please wait...' : 'loading...' }}</p>
  </div>
}
<div
  class="application-request neutral-theme"
  fxLayout="column"
  fxLayoutAlign="start center"
  [fxHide]="showSpinner"
>
  <div>
    <span class="title" fxLayoutAlign="center">{{ form?.displayTitle }}</span>
  </div>
  @if (!form?.hasExpired && !showVerificationCode) {
    <div fxLayout="column" fxLayoutAlign="start center">
      <div
        fxFlex
        class="instructions"
        [innerHTML]="form?.publicLinkInstructions | safeHtml"
      ></div>
      <div fxFlex class="default-instructions description">
        To complete the form, please enter your email address below and we’ll
        send you a direct link.
      </div>
      @if (!showVerificationCode) {
        <div fxFlex class="form-group-container">
          <form [formGroup]="requestForm" fxLayout="column">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex>
              <mat-label>Email address</mat-label>
              <input matInput type="text" formControlName="email" />
              @if (requestForm.get('email').hasError('required')) {
                <mat-error> Email is required </mat-error>
              }
              @if (requestForm.get('email').hasError('email')) {
                <mat-error> Email is in wrong format </mat-error>
              }
            </mat-form-field>
            @if (recaptchaSiteKey) {
              <re-captcha
                formControlName="recaptcha"
                [siteKey]="recaptchaSiteKey"
              ></re-captcha>
            }
          </form>
          <div class="button-container">
            <button
              mat-flat-button
              color="primary"
              (click)="requestApplication()"
              [disabled]="requestForm.invalid"
            >
              Next <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
  }
  @if (showVerificationCode) {
    <app-application-request-verification
      [applicationId]="applicationId"
      [email]="email"
      [errorMessage]="errorMessage"
    ></app-application-request-verification>
  }
  @if (form?.hasExpired) {
    <div fxFlex class="default-instructions description">
      We're sorry, {{ form?.displayTitle }} is no longer open.
    </div>
  }
</div>
